<template>
  <v-container>
    <delete-training-dialog
      :dialog="destroyTrainingDialog"
      :itemToBeDeleted="itemToBeDeleted"
      @close="closeDestroyTrainingDialog($event)"
    />
    <v-row
      class="align-center"
      mt-5
    >
      <v-col
        cols="3"
      >
        <search-field
          label="Busque por nome de Treino"
          :loading="loadingSearch"
          @searchText="searchText = $event"
        />
      </v-col>

    </v-row>
    <v-row
      mt-5
    >
      <v-col xs12>
        <v-data-table
          :headers="headers"
          :items="exercises"
          disable-pagination
          disable-sort
          hide-default-footer
          no-data-text=""
          loading-text="Carregando... Aguarde"
          class="elevation-1"
        >
          <template v-slot:item.link="{ item }">
            <a :href="item.link"
                v-if="item.link"
                target="_blank">Visualizar</a>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mr-2"
              fab
              x-small
            >
              <v-icon
                color="secondary"
                small
                @click="viewTrainingDetail(item)"
              >
                mdi-eye
              </v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              fab
              x-small
            >
              <v-icon
                color="secondary"
                small
                @click="downloadCurrentTrainingPdf(item)"
              >
                mdi-download
              </v-icon>
            </v-btn>
            <v-btn
              v-if="isMyScope(item)"
              fab
              x-small
            >
              <v-icon
                color="secondary"
                small
                @click="deleteTrainingItem(item)"
              >
                mdi-delete
              </v-icon>
            </v-btn>

          </template>
          <template v-slot:footer>
            <div class="full-width">
              <infinite-loading
                @infinite="infiniteHandler">
                <template slot="no-more">Não há mais itens cadastrados</template>
                <template slot="no-results">Não há itens cadastrados</template>
              </infinite-loading>
            </div>

          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <admin-training-detail
      v-if="selectedTraining"
      :readonly="true"
      :readOnlyForPersonal="true"
      @close="selectedTraining = null"
    />
  </v-container>

</template>

<script>
import DeleteTrainingDialog from '@/components/personal/configurations/exercises/DeleteTrainingDialog'
import AdminTrainingDetail from '@/components/admin/configurations/trainings/AdminTrainingDetail'
import { mapActions, mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import SearchField from '@/components/base/SearchField'
import LibraryService from '@/services/user-library-service'
import DocumentService from '@/services/document-service.js'

export default {
  name: 'LibraryList',
  components: {
    AdminTrainingDetail,
    DeleteTrainingDialog,
    InfiniteLoading,
    SearchField
  },
  mounted () {
    this.setLoader({ show: true })
  },
  data () {
    return {
      ...mapActions('base', ['setLoader', 'setSnackbar']),
      nextPage: 1,
      totalPages: 0,
      searchText: '',
      state: null,
      selectedTraining: null,
      resetList: false,
      exercises: [],
      headers: [
        { text: 'Treino', sortable: false, value: 'name' },
        { text: '', value: 'actions', width: 140, align: 'center' }
      ],
      loadingSearch: true,
      editedItem: {},
      itemToBeDeleted: {},
      createOrUpdateDialog: false,
      myLibrary: false,
      trainingLibrary: false,
      destroyTrainingDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    ...mapActions('base', ['fetchPdf']),
    ...mapActions('admin', ['setTrainingToBeEvaluated', 'setTrainingAdminDialog']),
    infiniteHandler ($state) {
      this.state = $state
      this.resetList = false
      if (this.nextPage === null) {
        $state.complete()
      } else {
        this.fetchTrainings()
      }
    },
    fetchTrainings () {
      LibraryService.all({ q: this.searchText, page: this.nextPage })
        .then(({ data }) => {
          if (data.trainings.length > 0) {
            if (this.resetList) {
              this.exercises = []
            }
            this.exercises.push(...data.trainings)
            this.nextPage = data.meta.next_page
            this.totalPages = data.meta.total_count
            this.state.loaded()
          } else {
            this.exercises = []
            this.state.complete()
          }
        })
        .catch(({ response }) => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: response.data.errors.detail
          })
        })
        .finally(() => {
          this.loadingSearch = false
          this.setLoader({ show: false })
        })
    },
    resetInfinityLoadAndPagination () {
      this.exercises = []
      this.state.reset()
      this.nextPage = 1
      this.resetList = true
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.createOrUpdateDialog = true
    },
    deleteItem (item) {
      this.itemToBeDeleted = item
      this.destroyDialog = true
    },
    deleteTrainingItem (item) {
      this.itemToBeDeleted = item
      this.destroyTrainingDialog = true
    },
    closeDestroyTrainingDialog () {
      this.destroyTrainingDialog = false
      this.resetInfinityLoadAndPagination()
    },
    isMyScope (exercise) {
      return exercise.personal_trainer_id === this.user.role_id
    },
    downloadCurrentTrainingPdf (item) {
      const payload = {
        trainingLibrary: item.id
      }
      const fileName = `Biblioteca - ${item.name}.pdf`

      this.setLoader({ show: true })
      this.fetchPdf({ service: DocumentService.getTrainingLibraryPdf, payload, fileName })
        .then(() => {
          console.log('PDF baixado com sucesso')
        })
        .catch(error => {
          const errorMessage = error.response && error.response.data && error.response.data.errors && error.response.data.errors.detail
            ? error.response.data.errors.detail
            : error.message || 'Erro desconhecido ao baixar PDF'
          this.setSnackbar({
            color: 'error',
            show: true,
            message: `Erro ao baixar PDF: ${errorMessage}`
          })
        })
        .finally(() => {
          this.setLoader({ show: false })
        })
    },
    viewTrainingDetail (item) {
      this.selectedTraining = item
      this.setTrainingToBeEvaluated(item)
      this.setTrainingAdminDialog(true)
    }
  },
  watch: {
    searchText () {
      const qLength = this.searchText.length
      if (qLength > 0 && qLength < 3) return
      this.loadingSearch = true
      this.resetInfinityLoadAndPagination()
    },
    trainingLibrary () {
      this.loadingSearch = true
      this.resetInfinityLoadAndPagination()
    }
  }
}
</script>
